import React, { memo, Fragment, useMemo, useEffect } from 'react';
import { Label, Row, Col } from 'reactstrap';
import { FormCheckbox, FormHTMLInline, FormInput } from '@core/components/form';
import { FormHTML } from '@core/components/form/FormHTML';
import { PricingBlockVariation } from './PricingBlock';
import { ProposalForm } from '@modules/proposal/ProposalBuilderPage';
import { useObservable } from '@core/utils/hooks/rxjs';
import { TableColumn } from '@modules/common/TableColumn';
import { TableActions } from '@modules/common/TableActions';

export interface PricingSettingsProps {
  form: ProposalForm;
  variation: PricingBlockVariation;
}

export const PricingSettings = memo((props: PricingSettingsProps) => {
  const { form, variation } = props;

  const pricingForm = useMemo(() => form.controls.pricing, [form.controls.pricing]);
  const sectionItems = useObservable(pricingForm.controls.sections.items$, []);

  return (
    <div>
      <Fragment>
        <Row>
          <Col md={9}>
            <Label>Introduction</Label>
            <FormInput control={pricingForm.controls.title} />
            <FormHTML minimal control={pricingForm.controls.optionalItemsTitle} />
            {/* <FormInput control={pricingForm.controls.optionalItemsTitle} /> */}
            {sectionItems.map((sec, index) => {
              return (
                <div className="d-flex" key={index}>
                  <TableColumn>
                    <FormHTML minimal control={sec.controls.sectionTitle} />
                    {/* <FormInput control={sec.controls.sectionTitle} /> */}
                  </TableColumn>
                  <TableColumn maxWidth={100}>
                    {/* add */}
                    <TableActions
                      onAdd={() => {
                        pricingForm.controls.sections.push();
                      }}
                      onDelete={() => {
                        pricingForm.controls.sections.removeAt(index);
                      }}
                    />
                  </TableColumn>
                </div>
              );
            })}
          </Col>
        </Row>
        <hr />
      </Fragment>
    </div>
  );
});
